import { useMutation } from "react-query";
import acknowledgementService from "../../services/acknowledgementService";

const useAcknowledgeDocument = () =>
  useMutation(acknowledgementService.acknowledge);

export default useAcknowledgeDocument;
